export default __webpack_public_path__ + "static/media/Flag_of_Aruba.4e87c2c2.svg";